<button [disabled]="disabled" [class.cursor-pointer]="disabled" (click)="onclick($event)">
  <mat-checkbox [disabled]="disabled" [(ngModel)]="enabled" color="primary" [ngClass]="{ small: small }">
    <ng-content></ng-content>
  </mat-checkbox>
</button>
